import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  CardContainer,
  CardImage,
  CardListContainer,
  CardText,
  CardTextContainer,
  GridContainerStyled,
  TaglineContainer,
  TaglineSubtitle,
  TaglineTitle,
} from "./styles";

export default function FreeSteps() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);
  const isMobile = useMediaQuery("(max-width:768px)");

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = content_my;

    const { solutions, solutionsCard } = response || {};
    setSolutions(solutions);
    setSolutionsCard(solutionsCard);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_steps",
    });
  }

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      {solutions?.map((solution, index) => (
        <>
          <TaglineContainer>
            <TaglineTitle
              dangerouslySetInnerHTML={{ __html: solution?.title }}
            ></TaglineTitle>

            <TaglineSubtitle
              dangerouslySetInnerHTML={{ __html: solution?.subtitle }}
            ></TaglineSubtitle>
          </TaglineContainer>
        </>
      ))}

      {isMobile ? (
        <>
          <CardContainer>
            {solutionsCard?.map((cards, cardIndex) => (
              <>
                <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                  <CardImage src={cards?.image?.data?.attributes?.url} />
                  <CardTextContainer>
                    <CardText
                      type={"title"}
                      cardNumber={cardIndex}
                      dangerouslySetInnerHTML={{ __html: cards?.title }}
                    ></CardText>
                    <CardText
                      type={"desc"}
                      cardNumber={cardIndex}
                      dangerouslySetInnerHTML={{ __html: cards?.description }}
                    ></CardText>
                  </CardTextContainer>
                </CardListContainer>
                {cardIndex == 0 && (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="62"
                      viewBox="0 0 15 62"
                      fill="none"
                    >
                      <path
                        d="M8.36401 1C8.36401 0.447715 7.9163 0 7.36401 0C6.81173 0 6.36401 0.447715 6.36401 1H7.36401L8.36401 1ZM7.36401 1H6.36401V4.75H7.36401H8.36401V1L7.36401 1ZM7.36401 12.25H6.36401V19.75H7.36401H8.36401L8.36401 12.25H7.36401ZM7.36401 27.25H6.36401V34.75H7.36401H8.36401V27.25H7.36401ZM7.36401 42.25H6.36401V49.75H7.36401H8.36401L8.36401 42.25H7.36401ZM7.36401 57.25H6.36401V61H7.36401H8.36401V57.25H7.36401Z"
                        fill="#261754"
                      />
                    </svg>
                  </>
                )}
                {cardIndex == 1 && (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15"
                      height="62"
                      viewBox="0 0 15 62"
                      fill="none"
                    >
                      <path
                        d="M8.36401 1C8.36401 0.447715 7.9163 0 7.36401 0C6.81173 0 6.36401 0.447715 6.36401 1H7.36401L8.36401 1ZM6.65691 61.7071C7.04743 62.0976 7.6806 62.0976 8.07112 61.7071L14.4351 55.3431C14.8256 54.9526 14.8256 54.3195 14.4351 53.9289C14.0446 53.5384 13.4114 53.5384 13.0209 53.9289L7.36401 59.5858L1.70716 53.9289C1.31664 53.5384 0.68347 53.5384 0.292946 53.9289C-0.0975785 54.3195 -0.0975785 54.9526 0.292946 55.3431L6.65691 61.7071ZM7.36401 1H6.36401V4.75H7.36401H8.36401V1L7.36401 1ZM7.36401 12.25H6.36401V19.75H7.36401H8.36401L8.36401 12.25H7.36401ZM7.36401 27.25H6.36401V34.75H7.36401H8.36401V27.25H7.36401ZM7.36401 42.25H6.36401V49.75H7.36401H8.36401L8.36401 42.25H7.36401ZM7.36401 57.25H6.36401V61H7.36401H8.36401V57.25H7.36401Z"
                        fill="#261754"
                      />
                    </svg>
                  </>
                )}
              </>
            ))}
          </CardContainer>
        </>
      ) : (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              alignItems: "center",
            }}
          >
            <CardContainer>
              {solutionsCard?.map((cards, cardIndex) => (
                <>
                  <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                    <CardImage src={cards?.image?.data?.attributes?.url} />
                  </CardListContainer>

                  {cardIndex == 0 && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="104"
                        height="30"
                        viewBox="0 0 104 30"
                        fill="none"
                      >
                        <path
                          d="M2 12.7279C0.89543 12.7279 0 13.6233 0 14.7279C0 15.8325 0.89543 16.7279 2 16.7279V14.7279V12.7279ZM2 14.7279V16.7279H6.16667V14.7279V12.7279H2V14.7279ZM14.5 14.7279V16.7279H22.8333V14.7279V12.7279H14.5V14.7279ZM31.1667 14.7279V16.7279H39.5V14.7279V12.7279H31.1667V14.7279ZM47.8333 14.7279V16.7279H56.1667V14.7279V12.7279H47.8333V14.7279ZM64.5 14.7279V16.7279H72.8333V14.7279V12.7279H64.5V14.7279ZM81.1667 14.7279V16.7279H89.5V14.7279V12.7279H81.1667V14.7279Z"
                          fill="#261754"
                        />
                      </svg>
                    </>
                  )}
                  {cardIndex == 1 && (
                    <>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="104"
                        height="30"
                        viewBox="0 0 104 30"
                        fill="none"
                      >
                        <path
                          d="M2 12.7279C0.89543 12.7279 0 13.6233 0 14.7279C0 15.8325 0.89543 16.7279 2 16.7279V14.7279V12.7279ZM103.414 16.1421C104.195 15.3611 104.195 14.0947 103.414 13.3137L90.6863 0.58577C89.9052 -0.195279 88.6389 -0.195279 87.8579 0.58577C87.0768 1.36682 87.0768 2.63315 87.8579 3.4142L99.1716 14.7279L87.8579 26.0416C87.0768 26.8227 87.0768 28.089 87.8579 28.87C88.6389 29.6511 89.9052 29.6511 90.6863 28.87L103.414 16.1421ZM2 14.7279V16.7279H6.16667V14.7279V12.7279H2V14.7279ZM14.5 14.7279V16.7279H22.8333V14.7279V12.7279H14.5V14.7279ZM31.1667 14.7279V16.7279H39.5V14.7279V12.7279H31.1667V14.7279ZM47.8333 14.7279V16.7279H56.1667V14.7279V12.7279H47.8333V14.7279ZM64.5 14.7279V16.7279H72.8333V14.7279V12.7279H64.5V14.7279ZM81.1667 14.7279V16.7279H89.5V14.7279V12.7279H81.1667V14.7279ZM97.8333 14.7279V16.7279H102V14.7279V12.7279H97.8333V14.7279Z"
                          fill="#261754"
                        />
                      </svg>
                    </>
                  )}
                </>
              ))}
            </CardContainer>

            <CardContainer>
              {solutionsCard?.map((cards, cardIndex) => (
                <>
                  <CardListContainer key={cardIndex} cardNumber={cardIndex}>
                    <CardTextContainer>
                      <CardText
                        type={"title"}
                        cardNumber={cardIndex}
                        dangerouslySetInnerHTML={{ __html: cards?.title }}
                      ></CardText>
                      <CardText
                        type={"desc"}
                        cardNumber={cardIndex}
                        dangerouslySetInnerHTML={{ __html: cards?.description }}
                      ></CardText>
                    </CardTextContainer>
                  </CardListContainer>
                </>
              ))}
            </CardContainer>
          </div>
        </>
      )}

      <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
    </GridContainerStyled>
  );
}
